// extracted by mini-css-extract-plugin
export default {"root":"YP4aY9hTSaDjZuJUOl91","alternative-maps":"SZoj4xmESQKTWgfeWNsi"};